module.exports = __webpack_public_path__ + "img/ics_o_download_pdf.1d77d9e6.svg";